import { useState } from 'react';
import { FormProps } from 'shared/interfaces/IModalForm';
import { ITalentAssetsProps } from 'shared/interfaces/ITalent';

export const useAssetsPropsForm = (data?: ITalentAssetsProps | undefined) => {
  const [selectedType, setSelectedType] = useState(data?.type || '');
  const [selectedItem, setSelectedItem] = useState(data?.item || '');

  const handleTypeChange = (value: string | null) => {
    if (value === selectedType) return;
    setSelectedType(value || '');
    setSelectedItem('');
  };
  const handleItemChange = (value: string | null) => {
    if (value === selectedItem) return;
    setSelectedItem(value || '');
  };

  const typeData = ['Instruments', 'Wardrobe', 'Sports Equipment'];
  const itemData = {
    instruments: ['Guitar', 'Piano', 'Violin'],
    wardrobe: ['Leather Jacket', 'Ripped Jeans', 'T-Shirt'],
    'sports equipment': ['Basketball', 'Tennis Racket', 'Baseball'],
  };

  const assetsPropsForm: FormProps<string> = {
    objectForm: [],
    stringForm: [
      {
        name: 'Type',
        list: typeData,
        value: selectedType,
        placeholder: selectedType,
        handleOnChange: handleTypeChange,
      },
      {
        name: 'Item',
        list: itemData[selectedType?.toLowerCase() as keyof typeof itemData] || [],
        value: selectedItem,
        placeholder: selectedItem,
        handleOnChange: handleItemChange,
      },
    ],
  };

  return { selectedType, selectedItem, assetsPropsForm };
};
